import { CMSComponentData } from '../types/cms-component-data.type';
export const buildTabComponentRegistry = (
  components: CMSComponentData[],
): { [key: string]: Object } =>
  components.reduce((componentRegistry, component) => {
    componentRegistry[component.name] = component.data;
    return componentRegistry;
  }, {});
